module.exports = __webpack_public_path__ + "static/img/background.741a1f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/background.png
// module id = J24T
// module chunks = 2 3